// Deriva o título exibido na aba a partir da localização. Rótulos vêm do menu (fonte única `adminNav`);
// rotas de detalhe (com :id) recebem um rótulo específico.
import { NAV, isGroup } from "@/layouts/adminNav";
import { tabKeyOf, type TabLocation } from "./tabModel";

const LABELS: Record<string, string> = {};
for (const entry of NAV) {
  if (isGroup(entry)) {
    for (const item of entry.items) LABELS[item.to] = item.label;
  } else {
    LABELS[entry.to] = entry.label;
  }
}

export function titleForAdminLocation(loc: TabLocation): string {
  const key = tabKeyOf(loc.pathname);
  if (LABELS[key]) return LABELS[key];

  // Rotas de detalhe (ids variáveis) não estão no menu.
  const pedido = key.match(/^\/admin\/pedidos\/(.+)$/);
  if (pedido && pedido[1] !== "novo") return "Pedido";
  if (/^\/admin\/frota\/[^/]+$/.test(key)) return "Veículo";
  if (/^\/admin\/selecao\/[^/]+\/candidatos$/.test(key)) return "Candidatos";
  if (/^\/admin\/selecao\/[^/]+\/ranking$/.test(key)) return "Ranking";
  if (/^\/admin\/selecao\/[^/]+\/ajustes$/.test(key)) return "Ajustes";
  if (/^\/admin\/selecao\/candidatos\/[^/]+$/.test(key)) return "Avaliação";
  // Detalhe do estabelecimento: rótulo genérico até a tela carregar e definir o nome da empresa
  // dinamicamente (via useTabTitle). Evita exibir o UUID da rota.
  if (/^\/admin\/estabelecimentos\/[^/]+$/.test(key)) return "Estabelecimento";

  const seg = key.split("/").filter(Boolean).pop() ?? "Admin";
  return seg.charAt(0).toUpperCase() + seg.slice(1);
}
